module.exports = ".login {\n  width: 40%;\n}\n.login p {\n  color: #888;\n  margin-bottom: 1em;\n  line-height: 1.4em;\n}\n.login .mat-card-content.loading {\n  text-align: center;\n}\n.login .mat-card-content.loading .mat-progress-spinner {\n  margin: 0 auto;\n}\n.login .mat-card-actions button {\n  cursor: pointer;\n  color: #074A89;\n}\n.login .mat-card-actions button i {\n  vertical-align: middle;\n  margin-bottom: 3px;\n  cursor: pointer;\n}\nmain {\n  min-height: calc(100vh - 264px);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./Angular/app/login/login.component.less
// module id = ./Angular/app/login/login.component.less
// module chunks = main